export const BG_IMAGES = {
  institut:'https://res.cloudinary.com/dxbfpabjs/image/upload/v1770656248/IMG_9339_1_slar3y.jpg',
  // Logo pour le Lycée Français
  lyceeFrancais: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884026/18082000-DJI_20000818060052_0359_D-min_ydunsu_anp6n4.jpg',
  
  // Logo pour le Lycée Ivoirien
  lyceeIvoirien: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789883999/amelioerer_qwwaja.png',
  
  // Logo pour Maternelle & Primaire
  maternellePrimaire: 'https://res.cloudinary.com/dzc0bh0kf/image/upload/v1789884020/18082000-DJI_20000818055508_0343_D_p6dzmx_wqdgfk.jpg',

}